var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 31 32.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4595 1.0246H15.5331C19.4183 1.03362 22.9678 2.47077 25.6828 4.83832C25.8753 5.00608 25.7534 5.31397 25.498 5.31397H5.49455C5.23916 5.31397 5.1173 5.00608 5.3097 4.83832C8.02484 2.47077 11.5742 1.03362 15.4595 1.0246Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46829 20.7157C9.35743 20.5578 9.17891 20.4586 8.98581 20.4586H0.970568C0.738371 20.4586 0.569075 20.6786 0.634964 20.901C2.53267 27.3059 8.46803 31.9792 15.4962 31.9792C22.5244 31.9792 28.4598 27.3059 30.3575 20.901C30.4233 20.6786 30.254 20.4586 30.0219 20.4586H22.0068C21.8137 20.4586 21.6351 20.5578 21.5243 20.7157C20.1935 22.6109 17.9899 23.8499 15.4963 23.8499C13.0028 23.8499 10.799 22.6109 9.46829 20.7157Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3318 12.0253C21.4735 12.2093 21.6892 12.3247 21.9217 12.3247H29.9548C30.1892 12.3247 30.3588 12.1012 30.2889 11.8778C29.6819 9.93811 28.703 8.16249 27.4356 6.63422C27.33 6.507 27.1724 6.43518 27.0071 6.43518H3.98477C3.81939 6.43518 3.66181 6.507 3.55632 6.63422C2.28888 8.16248 1.30996 9.93811 0.702907 11.8778C0.632983 12.1012 0.802683 12.3247 1.03705 12.3247H9.07018C9.30259 12.3247 9.51837 12.2093 9.66005 12.0253C11.0051 10.2782 13.1189 9.1523 15.4959 9.1523C17.8731 9.1523 19.9868 10.2782 21.3318 12.0253Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6053 19.339C22.4534 19.339 22.3504 19.1846 22.4029 19.0424C22.6944 18.2512 22.8536 17.3961 22.8536 16.504C22.8536 15.5312 22.6643 14.6027 22.3208 13.753C22.2627 13.6097 22.3661 13.4496 22.5208 13.4496H30.4005C30.5691 13.4496 30.7149 13.5684 30.745 13.7343C30.9075 14.633 30.9923 15.5587 30.9923 16.5041C30.9923 17.371 30.921 18.2212 30.7838 19.0494C30.756 19.2176 30.6091 19.339 30.4386 19.339H22.6053ZM8.58954 19.0424C8.64195 19.1846 8.53885 19.339 8.38712 19.339H0.553861C0.383187 19.339 0.236371 19.2176 0.208514 19.0494C0.0713531 18.2212 0 17.371 0 16.5041C0 15.5587 0.0848803 14.633 0.247445 13.7343C0.277445 13.5684 0.42317 13.4496 0.591906 13.4496H8.47162C8.62634 13.4496 8.72958 13.6097 8.67163 13.753C8.32797 14.6027 8.13877 15.5312 8.13877 16.504C8.13877 17.3961 8.29797 18.2512 8.58954 19.0424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/ORDER.cb2130642e0c2eb58b54d6ff4a9cae76.svg";
export { ForwardRef as ReactComponent };